import { useDispatch } from "react-redux";
import { Button, Modal } from "antd";
import { bulkAddToLead } from "../../actionCreator/leadListingActionCreater";
import { useAlert } from "../../context/AlertProvider";
import { getUserInfo } from "../../utils/utils";
import { convertDataToLead } from "../../actionCreator/importActionCreator";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const BulkAddToLead = ({
  isImportLead,
  isOpen,
  handleCancel,
  selectedItems,
  callback,
}) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const { id: userId } = getUserInfo();
  const alreadyAdded = selectedItems?.filter((d) => d?.isLead)?.length;

  const onAddToLead = async () => {
    if (isImportLead) {
      const res = await dispatch(
        convertDataToLead(
          selectedItems
            ?.filter((d) => !d?.alreadyClientLead)
            ?.map((d) => d?.id),
        ),
      );

      if (res.status === 201) {
        const count = selectedItems
          ?.filter((d) => !d?.alreadyClientLead)
          ?.map((d) => d?.id)?.length;
        searchParams.set("status", "success");
        navigate(`${location.pathname}?${searchParams.toString()}`, {
          state: {
            prompt: count,
          },
        });
        callback && callback();
      } else {
        showAlert(
          "error",
          res?.response?.status === 500
            ? "Something went wrong. Please try again."
            : res?.response?.data?.title,
        );
      }
    } else {
      const data = selectedItems
        ?.filter((d) => !d?.isLead)
        ?.map(({ id, ...i }) => ({
          ...i,
          userId,
          status: 11,
          employeeId: id,
        }));
      const res = await dispatch(
        bulkAddToLead({
          clientLeads: data,
        }),
      );
      if (res.status === 201) {
        showAlert(
          "success",
          "Selected records have been successfully added to the lead.",
        );
        callback && callback();
      } else {
        const isLimitExceed = res?.response?.data?.title
          ?.toLowerCase()
          ?.includes("subscriber ussage limit expired");
        showAlert(
          "error",
          isLimitExceed
            ? "You have exceeded your maximum lead creation limit."
            : res?.response?.data?.title,
        );
      }
    }
  };

  return (
    <Modal
      title={
        <span className="tw-text-base tw-font-bold tw-text-slate-800">
          Add to lead
        </span>
      }
      width="400px"
      closable
      centered
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button
          key="cancel"
          onClick={handleCancel}
          className="tw-border-slate-200 hover:tw-border-slate-300 tw-text-slate-655 hover:tw-text-slate-800 tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-5"
        >
          Cancel
        </Button>,
        alreadyAdded !== selectedItems?.length && (
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              onAddToLead();
              handleCancel();
            }}
            className="!tw-bg-emerald-600 hover:!tw-bg-emerald-500 !tw-border-emerald-600 tw-text-white tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-6"
          >
            Add to lead
          </Button>
        ),
      ]}
    >
      <div className="tw-mt-4 tw-text-xs tw-font-medium tw-text-slate-600 tw-leading-relaxed tw-font-inter">
        {alreadyAdded === selectedItems?.length
          ? `All selected ${selectedItems?.length} contacts have already been added to the leads.`
          : alreadyAdded
            ? `You’ve selected ${selectedItems?.length} contacts. ${alreadyAdded} of them already exists in the lead list. Do you want to add the remaining ${selectedItems?.length - alreadyAdded}?`
            : `Are you sure you want to add the selected ${selectedItems?.length} ${selectedItems?.length > 1 ? "contacts" : "contact"} to the lead?`}
      </div>
    </Modal>
  );
};

export default BulkAddToLead;
